import { createSelector } from '@ngrx/store';
import { getCitation } from './get.citations';

export const getCreatedReferenceId = createSelector(
  getCitation,
  ({ createdReferenceId }): string | null | undefined => createdReferenceId
);
